namespace TabAurous.Sales {
    export namespace CustomerSalesItemsService {
        export const baseUrl = 'Sales/CustomerSalesItems';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ProductTypeList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CategoryList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SubCategoryList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/CustomerSalesItems/List",
            ProductTypeList = "Sales/CustomerSalesItems/ProductTypeList",
            CategoryList = "Sales/CustomerSalesItems/CategoryList",
            SubCategoryList = "Sales/CustomerSalesItems/SubCategoryList"
        }

        [
            'List', 
            'ProductTypeList', 
            'CategoryList', 
            'SubCategoryList'
        ].forEach(x => {
            (<any>CustomerSalesItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
